var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"Dialog",class:this.type,attrs:{"id":"PromptDialog","title":this.scopedStrings[this.type]}},[_c('p',{staticClass:"message",domProps:{"innerHTML":_vm._s(this.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }